export default __webpack_public_path__ + "static/media/warning.4ee11e34.svg";